// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common_table[data-v-dd2f59e6]{width:100%}.common_table tbody tr[data-v-dd2f59e6]:hover,.common_table tbody tr[data-v-dd2f59e6]:nth-child(odd){background-color:rgba(61,107,255,.1)}.common_table .content_item[data-v-dd2f59e6]{padding:0 10px}", ""]);
// Exports
module.exports = exports;
